module.exports = __webpack_public_path__ + "static/media/three-days.60a862e0.png";